import React from 'react';

const Footer = () => {
    return (
        <footer className="text-center py-3 position-fixed bottom-0 w-100">
            <p className="mb-0">© 2025 Alejandro Espada. Todos los derechos reservados.</p>
        </footer>
    );
};

export default Footer;
